import React, { useState, useEffect } from 'react';
//import axios from 'axios';
import { getEstablishmentsByGroupOrRegion } from "../../services/establishement.service";
import { DropDownItem } from "../UIElements";
import DropDown from '../UIElements/DropDown';

interface Option {
    id: number;
    name: string;
  }
  
  interface SelectProps {
    groupId: number | null | undefined;
    regionId?: number | null | undefined;
    onSelect: (selectedValue: string) => void;
  }
  
  const SelectEstablishement: React.FC<SelectProps> = ({ groupId, regionId, onSelect }) => {
    const [options, setOptions] = useState<DropDownItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedItem, setSelectedValue] = useState<string>('');
  
    useEffect(() => {
        if(null == groupId){
            console.error("groupId cannot be null or undefined")
            return;
        }
      const fetchData = async () => {
        try {
          const data = regionId == null ? await getEstablishmentsByGroupOrRegion(groupId) : await getEstablishmentsByGroupOrRegion(groupId, regionId);
          const opts:DropDownItem[] = data.map((d: { id: any; companyName: any; }) => {
            return {
              id: d.id,
              name: d.companyName
            }
          });
          setOptions(opts);
          setLoading(false);
        } catch (err) {
          setError('Failed to fetch options.');
          setLoading(false);
        }
      };
  
      fetchData();
    }, [groupId, regionId]);
  
    const handleChange = (selectedValue: any) => {
      onSelect(selectedValue ? selectedValue.target.value.toString() : '');
    };
    if (loading) {
      return <p>Loading options...</p>;
    }
  
    if (error) {
      return <p>{error}</p>;
    }
  
    return  (
      <DropDown
        items={options}
        inputlabel="Sélectionner un établissement"
        onChange={handleChange}
      />
    );
  };
  
  export default SelectEstablishement;